export const containHalfWidthString = (str?: string | null) => {
  const regex = /^.*[\x20-\x7E\uFF65-\uFF9F]+.*$/;
  return str?.match(regex);
};
